/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Sep 08, 2016
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

/**
 * Keeps track of the permissions granted a Manager for a User's data
 * @type {Model}
 */
module.exports = Model({
	name: "managementpermissions",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_user: null,
	_group: null,
	_manager: null,

	handle_permissionsUpdate: handle_permissionsUpdate,
	handle_update: handle_update,
	refresh: refresh,
	pushList: pushList

});

/**
 * Retrieves the permissions, ie. the 'managing' property of the manager
 * @return {[type]} [description]
 */
function init() {
	this._group_tracker = this.dispatcher.createTracker();
	this._user = null;
	this._group = null;
	this.push({});
}

/**
 * Removes all listeners from the dispatcher
 */
function uninit() {
	this._user = null;
}

/**
 * Whenever there is an update of 'managedusers', a refresh of the permissions
 * data is initiated.  Whenever a permissions update message relevant to this
 * manager is issued, a refresh of the permissions data is initiated.
 */
function listeners() {
	return {
		"managedaccount:updated": handle_update,
		"connectivity:online": refresh,
	};
}

/**
 * The model can be triggered to supply the permission for access to a given User's
 * data ie. when a manager clicks to open an information item, the item is
 * displayed or an error is displayed.
 */
function triggers() {
	return {
		permissions: handle_update
	};
}

function handle_permissionsUpdate(data) {
	var user = data._id;
	if (user !== this._user || !this._user) return;
	this.push(data);
}

function handle_update(data) {
	var open = data.open;
	if (!open) {
		if(this._user){
			this._user = null;
			this._group = null;
			this.push({});
		}
	} else {
		var user = data.data;
		this._user = user._id;
		this._group = data.group;
		this.refresh();
	}
}

function refresh() {
	const user = this._user;
	const group = this._group;
	if(!user) return;
	this.emit("save:trigger:start");
	return this.api.manage.permissions.list(user, group)
		.then(pushList.bind(this))
		.catch(console.error.bind(console))
		.then(finish_save.bind(this))
		.then(trackGroup.bind(this));
}

function trackGroup(){
	var group = this._group;
	var groupTracker = this._group_tracker;

	groupTracker.off();
	if(group) groupTracker.on(`mqtt:managegroup/${group}/permissions/updated`, pushList.bind(this));
	else groupTracker.on("mqtt:$/manage/permissions/updated", handle_permissionsUpdate.bind(this));
}

function finish_save() {
	this.emit("save:trigger:finish");
}

function pushList(list) {
	this.push(list);
}